// Generated by https://pagedraw.io/pages/12008
import React from 'react';
import './buttonwithstate.css';


export default class Buttonwithstate extends React.Component {
  render() {
    return (
      <div className="buttonwithstate">
          { ((this.props.state === 'selected' ? 'selected' : 'unselected') === "unselected") ?
              <div className="buttonwithstate-unselected-3">
                  <div className="buttonwithstate-0-0-0">
                      <div className="buttonwithstate-buttonunselectedstate-4">
                          <div className="buttonwithstate-0-0-0-0-0">
                              <div className="buttonwithstate-unselectedtext-1">
                                  { this.props.text2 }
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          : null}
          { ((this.props.state === 'selected' ? 'selected' : 'unselected') === "selected") ?
              <div className="buttonwithstate-selected-8">
                  <div className="buttonwithstate-1-0-0">
                      <div className="buttonwithstate-buttonselectedstate-8">
                          <div className="buttonwithstate-1-0-0-0-0">
                              <div className="buttonwithstate-selectedtext-4">
                                  { this.props.text }
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          : null}
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/pagedraw/buttonwithstate.js